export default "__VITE_ASSET__6bf68462__"